export { BaseExtension } from './baseExtension';

export type { Extension } from './types';



// WEBPACK FOOTER //
// ../../../src/extensions/index.ts